import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class McLoaderService {

  private loaderSubject = new BehaviorSubject<boolean>(true);

  loaderState = this.loaderSubject.asObservable();

  constructor() { }

  showLoading() {
    this.loaderSubject.next(true);
  }

  hideLoading() {
    this.loaderSubject.next(false);
  }

  destroy() {
    if (this.loaderSubject) {
      this.loaderSubject.unsubscribe();
    }
  }
}